import { Pipe, PipeTransform } from "@angular/core"

@Pipe({
    name: "langsDistinct",
    pure: false,
    standalone: true,
})
export class LangsDistinctPipe implements PipeTransform {
    transform(value: any[], field: string): string[] {
        if (!value || !field) return []
        const langsArr: string[] = []
        value.forEach(item => {
            if (!item[field]) return
            const langs = Object.keys(item[field])
            langs.forEach(lang => {
                if (!langsArr.includes(lang)) {
                    langsArr.push(lang)
                }
            })
        })
        return langsArr
    }
}
